module.exports = __webpack_public_path__ + "static/media/notfound.ce3cf8a5.png";